import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=1ad2587b&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=1ad2587b&prod&scoped=true&lang=css"
import style1 from "./Detail.vue?vue&type=style&index=1&id=1ad2587b&prod&lang=css"
import style2 from "spinkit/scss/spinkit.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad2587b",
  null
  
)

export default component.exports